import { Megaphone } from "lucide-react";
import type { LineageNode } from "../types";
import { NodeShell } from "./NodeShell";

interface Props {
  data: LineageNode;
  selected?: boolean;
}

export function CampaignJobPostingNode({ data, selected }: Props) {
  return <NodeShell node={data} icon={Megaphone} selected={selected} />;
}
